/**
 * 按应用名控制的特色能力
 * 后续某品牌要开/关某功能，只改这里对应数组即可
 */
export const APP_FEATURES = {
  /** 首页导出账单 */
  exportBill: ['预安企护'],
  /** 报案：医院是否公立二级以上 */
  publicGrade2Hospital: ['预安企护'],
  /** 报案：诊断结果 / 客户预估金额 */
  lgdCaseExtra: ['蓝工盾'],
  /** 报案：及时宝上传文案 */
  jsbInjuryUploadTitle: ['及时宝'],
  /** 个人设置：允许改密码 */
  passwordEdit: ['蓝工盾', '及时宝', '企护星'],
  /** 在保方案：截单时间 */
  closeTime: ['企护星', '及时宝'],
  /** 在保方案：预安方案提示浮层 */
  planTips: ['预安企护'],
  /** 充值汇款备注：服务费（否则为保费+服务费） */
  remittanceServiceFee: ['预安企护', '企护星'],
  /** 报案列表：负责人列 */
  caseDirector: ['蓝工盾'],
  /** 报案列表：及时宝活动图 */
  jsbActivityImage: ['及时宝'],
  /** 首页：及时宝额外模块 */
  jsbHome: ['及时宝'],
  /** 加保确认：特别约定 + 方案条款 */
  addPlanAgreement: ['安心优选'],
  /** 被派遣单位：企护星工作视频说明 */
  dispatchVideoTips: ['企护星'],
  /** 侧栏：知识库 */
  wikiMenu: ['预安企护']
} as const

export type AppFeature = keyof typeof APP_FEATURES
